module.exports = __webpack_public_path__ + "static/media/9.27482e22.jpeg";